import Constants from '../../constants';
import PropertiesConstants from '../../constants/PropertiesConstants';

const initState = () => ({
  includeActive: Constants.PROPERTIES_ACTIVE_DEFAULT,
  includeInactive: Constants.PROPERTIES_INACTIVE_DEFAULT,
  includeArchived: Constants.PROPERTIES_INCLUDE_ARCHIVED,
  includeUnarchived: Constants.PROPERTIES_INCLUDE_UNARCHIVED,
  includeAtRisk: Constants.PROPERTIES_INCLUDE_AT_RISK,
  limit: Constants.PROPERTIES_LIMIT_DEFAULT,
  searchText: Constants.PROPERTIES_SEARCHTEXT_DEFAULT,
  startKeyExclusive: Constants.PROPERTIES_START_KEY_EXCLUSIVE_DEFAULT,
  subNavFilterType: PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ALL,
  viewType: '',
});

const propertiesFilters = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case Constants.UPDATE_PROPERTIES_FILTERS:
      return { ...state, ...payload };

    default:
      return state;
  }
};

export default propertiesFilters;
